import $ from 'jquery';
import "jquery-validation";

export default function ContactForm() {

    // Wait for the DOM to be ready
    $(function () {
        // Initialize form validation on the registration form.
        // It has the name attribute "registration"
        $("form[name='contact-form']").validate({
            submitHandler: function (form) {
                //form.submit();
                // get the form data
                // there are many ways to get this data using jQuery (you can use the class or id also)
                var formData = {
                    'subject': $('input[name=subject2]').val(),
                    'formId': $('input[name=formId]').val(),
                    'salute': $('select[name=salute]').val(),
                    'firstname': $('input[name=firstname]').val(),
                    'lastname': $('input[name=lastname]').val(),
                    'email': $('input[name=email]').val(),
                    'phone': $('input[name=phone]').val(),
                    'message': $('textarea[name=message]').val(),
                };
                // Hide the Form
                $('.form-data').hide();
                $('.loading').show();
                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/contacts/add",
                    content: "application/json; charset=utf-8",
                    dataType: "json",
                    data: formData,
                    success: function (d) {
                        $('.loading').hide();
                        if (d.statusCode == 0) {
                            $('.message-ok').show();
                            $('.message-error').hide();
                        }
                        else {
                            $('.message-ok').hide();
                            $('.message-error').show();
                        }
                    },
                    error: function (d) {
                        $('.loading').hide();
                        $('.message-ok').hide();
                        $('.message-error').show();
                    }
                });
            }
        });
    });
}